import { createStyles, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import { IKImage } from "imagekitio-react";
import { selectComponentDimensions } from "../../../../../redux/slices/landingSlice";
import { PFXItem, PFXTextAttributes } from "../../../../../models/Interfaces";
import { useSelector } from "react-redux";
import fallback_img from "../../../../../images/fallback_item.png";
import { PFXCategoryItem } from "../../../../../redux/slices/templateSlice";
import useLandingFunctions from "../../../../../hooks/useLandingFunctions";

interface ICategoriesProductCard {
  item: PFXCategoryItem;
  text: PFXTextAttributes;
  color: string;
  onClick: () => void;
}

const CategoriesProductCard = ({ item, color, onClick }: ICategoriesProductCard) => {
  const { height } = useSelector(selectComponentDimensions);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        marginRight: 8,
        maxWidth: `calc(${height}px * 0.5)`,
      },
      card: {},
      image: {
        width: `calc(${height}px * 0.5)`,
        height: `calc(${height}px * 0.5)`,
        // minWidth: `calc(${height}px * 0.5)`,
        // width: `100%`,
        // height: `100%`,

        borderRadius: 9,
        objectFit: "cover",
      },
    })
  );

  const classes = useStyles();

  const imagePath = useMemo(() => {
    if (!item || !item?.images) return undefined;
    return item?.images && item.images.length > 0 && item.images[0]
      ? item.images[0].split("cleverlynk-imgs.s3.amazonaws.com")[1]
      : undefined;
  }, [item]);

  return (
    <Grid item container direction="column" xs={7} className={classes.root} onClick={onClick}>
      <Grid item>
        {imagePath ? (
          <IKImage
            id={`expanded-${item?.id}-${imagePath}`}
            key={`expanded-${item?.id}-${imagePath}`}
            className={classes.image}
            style={{
              position: "relative",
            }}
            path={imagePath}
            transformation={[
              {
                height: 350,
                width: 350,
              },
            ]}
            loading="lazy"
            lqip={{ active: true, quality: 20, blur: 10 }}
          />
        ) : (
          <img
            src={fallback_img}
            style={{
              margin: "0 auto",
            }}
            className={classes.image}
            alt={"fallback item"}
          />
        )}
      </Grid>
      <Grid item container direction="column">
        <Grid item>
          <Typography variant="caption" style={{ color }}>
            {item.name}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="caption" style={{ color }}>
            {item.price}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default CategoriesProductCard;
